import { createFileRoute } from "@tanstack/react-router";
import MedCostInsurance, { config } from "@/pages/MedCostInsurance";
import { buildInsuranceSchema } from "@/components/InsurancePageTemplate";
export const Route = createFileRoute("/medcost-insurance")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "MedCost TMS Coverage | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Have MedCost insurance? Learn about TMS therapy, SAINT TMS, and depression treatment options that may be available through your MedCost plan in Coral.",
        },
        {
          property: "og:title",
          content: "MedCost TMS Coverage | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Have MedCost insurance? Learn about TMS therapy, SAINT TMS, and depression treatment options that may be available through your MedCost plan in Coral.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/medcost-insurance",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/medcost-insurance",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(buildInsuranceSchema(config)),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <MedCostInsurance />;
}
